import React, {Fragment} from "react";
import TextInput from "../../../form/TextInput";
import {CurrencyFormatter} from "../../../../utils/formatters";

export default class StornoVatRateClosing extends React.Component<any, any> {

    setFieldValue = (data) => {
        this.props.setFieldValue && this.props.setFieldValue("vatrate_closings", data)
    }

    render() {
        const vatrate_closings = (this.props.values.vatrate_closings || []);
        return (
            !!vatrate_closings.length && <Fragment>
                <label className="control-label">Gyűjtők</label>
                <div className="row">
                    {
                        vatrate_closings.map((closing, index) => {
                            return (
                                <Fragment key={index}>
                                    <div className={"col-md-" + Math.ceil(12 / vatrate_closings.length)}>
                                        <div className="form-group currency">
                                            <TextInput
                                                name="storno_amount"
                                                type="decimal"
                                                value={closing.storno_amount}
                                                disablePaste={true}
                                                label={closing.vatrate.name + " sztornó"}
                                                disabled={this.props.isLoading}
                                                formatter={CurrencyFormatter}
                                                required={true}
                                                saveChanges={(field, value) => {
                                                    const vatrate_closings = JSON.parse(JSON.stringify(this.props.values.vatrate_closings || []));
                                                    vatrate_closings[index][field] = value;
                                                    this.setFieldValue(vatrate_closings);
                                                }}
                                                {...this.props.getFieldProps("vatrate_closings." + index + ".storno_amount")}
                                            />
                                        </div>
                                    </div>
                                </Fragment>
                            );
                        })
                    }
                </div>
            </Fragment>
        );
    }
}
